function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var UserStoreNavTemplate = require('./user-store-sidebar.template');
var SaitoProfile = require('../../../../lib/saito/ui/saito-profile/saito-profile');

/**
 * User-store profile context: shared SaitoProfile (read-only) with Store nav
 * injected into the profile card footer slot, plus Store-owned attribution
 * below the card (outside SaitoProfile).
 *
 * Footer follows the Red Square pattern: host owns the slot; Chat is opened
 * via connection events (no hard Chat module API).
 */
var UserStoreSidebar = /*#__PURE__*/function () {
  function UserStoreSidebar(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, UserStoreSidebar);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.publicKey = '';
    this.profile = new SaitoProfile(app, mod, '');
    // Public storefront is always read-only (no camera / pencil).
    this.profile.editable = false;
  }
  return _createClass(UserStoreSidebar, [{
    key: "hasChat",
    value: function hasChat() {
      var _this$app$modules, _this$app$modules$ret;
      return Boolean((_this$app$modules = this.app.modules) === null || _this$app$modules === void 0 || (_this$app$modules$ret = _this$app$modules.returnModuleBySlug) === null || _this$app$modules$ret === void 0 ? void 0 : _this$app$modules$ret.call(_this$app$modules, 'chat'));
    }
  }, {
    key: "isOwnStore",
    value: function isOwnStore() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.publicKey;
      return Boolean(publicKey && this.mod.publicKey && publicKey === this.mod.publicKey);
    }

    /**
     * @returns {Array<{ action: string, label: string, icon: string }>}
     */
  }, {
    key: "returnNavItems",
    value: function returnNavItems() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.publicKey;
      var items = [];
      var key = String(publicKey || '').trim();
      if (key && this.hasChat() && !this.isOwnStore(key)) {
        items.push({
          action: 'send-message',
          label: 'Send Message',
          icon: 'fa-solid fa-lock'
        });
      }
      if (this.isOwnStore(publicKey)) {
        items.push({
          action: 'admin-store',
          label: 'Manage Store',
          icon: 'fa-solid fa-gear'
        });
      }
      return items;
    }

    /** Canonical marketplace path — same slug routing as Store header / setBrowseUrl. */
  }, {
    key: "marketplacePath",
    value: function marketplacePath() {
      var _this$mod$returnSlug, _this$mod;
      return "/".concat(encodeURI(((_this$mod$returnSlug = (_this$mod = this.mod).returnSlug) === null || _this$mod$returnSlug === void 0 ? void 0 : _this$mod$returnSlug.call(_this$mod)) || 'store'));
    }
  }, {
    key: "openMarketplace",
    value: function openMarketplace(e) {
      if (e) {
        e.preventDefault();
      }
      var path = this.marketplacePath();
      if (typeof navigateWindow === 'function') {
        navigateWindow(path);
      } else {
        window.location.assign(path);
      }
    }
  }, {
    key: "openAdminStore",
    value: function openAdminStore() {
      var _this$mod$main, _this$mod$returnAdmin, _this$mod2;
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.publicKey;
      var key = String(publicKey || '').trim();
      if (!key || !this.isOwnStore(key)) {
        return;
      }
      if (typeof ((_this$mod$main = this.mod.main) === null || _this$mod$main === void 0 ? void 0 : _this$mod$main.openStorefront) === 'function') {
        void this.mod.main.openStorefront(key, {
          admin: true
        });
        return;
      }
      var path = ((_this$mod$returnAdmin = (_this$mod2 = this.mod).returnAdminPath) === null || _this$mod$returnAdmin === void 0 ? void 0 : _this$mod$returnAdmin.call(_this$mod2, key)) || "".concat(this.marketplacePath(), "/").concat(encodeURIComponent(key), "/admin");
      if (typeof navigateWindow === 'function') {
        navigateWindow(path);
      } else {
        window.location.assign(path);
      }
    }
  }, {
    key: "openChat",
    value: function openChat() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.publicKey;
      var key = String(publicKey || '').trim();
      if (!key || !this.hasChat()) {
        return;
      }
      // ChatManager owns the open-chat-with listener; create it if needed
      // (same side-effect Chat's user-menu uses before emitting).
      this.app.modules.returnFirstRespondTo('chat-manager');
      this.app.connection.emit('open-chat-with', {
        key: key,
        activate: true
      });
    }
  }, {
    key: "renderNav",
    value: function renderNav() {
      var footer = this.profile.getFooterEl();
      if (!footer) {
        return;
      }
      footer.innerHTML = UserStoreNavTemplate(this.returnNavItems(this.publicKey));
      this.attachNavEvents();
    }
  }, {
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var publicKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (container) {
        this.container = container;
      }
      var key = String(publicKey || this.publicKey || '').trim();
      if (!this.container || !key) {
        return;
      }
      this.publicKey = key;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      var marketPath = this.marketplacePath();
      root.innerHTML = "\n      <div class=\"user-store-profile\"></div>\n      <p class=\"user-store-attribution\">\n        Listings indexed on the\n        <a href=\"".concat(marketPath, "\" data-store-attribution=\"marketplace\">Saito Store</a>\n      </p>\n    ");
      this.profile.editable = false;
      this.profile.container = "".concat(this.container, " .user-store-profile");
      this.profile.reset(key);
      this.profile.editable = false;
      this.profile.render();
      this.renderNav();
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      root.querySelectorAll('[data-store-attribution="marketplace"]').forEach(function (link) {
        link.onclick = function (e) {
          return _this.openMarketplace(e);
        };
      });
      this.attachNavEvents();
    }
  }, {
    key: "attachNavEvents",
    value: function attachNavEvents() {
      var _this2 = this;
      var footer = this.profile.getFooterEl();
      if (!footer) {
        return;
      }
      footer.querySelectorAll('.user-store-nav .item[data-nav-action]').forEach(function (item) {
        item.onclick = function (e) {
          e.preventDefault();
          _this2.activateNav(item.getAttribute('data-nav-action') || '');
        };
        item.onkeydown = function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            _this2.activateNav(item.getAttribute('data-nav-action') || '');
          }
        };
      });
    }
  }, {
    key: "activateNav",
    value: function activateNav() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (action === 'admin-store') {
        this.openAdminStore(this.publicKey);
        return;
      }
      if (action === 'send-message') {
        this.openChat(this.publicKey);
      }
    }
  }]);
}();
module.exports = UserStoreSidebar;